var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#9E120E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 12.705C12.6124 12.705 12.2417 12.5514 11.9684 12.2781C11.695 12.0048 11.5415 11.6341 11.5415 11.2475C11.5415 10.861 11.695 10.4902 11.9684 10.2169C12.2417 9.94356 12.6124 9.79 12.999 9.79C13.3855 9.79 13.7562 9.94356 14.0296 10.2169C14.3029 10.4902 14.4565 10.861 14.4565 11.2475C14.4565 11.4389 14.4188 11.6284 14.3455 11.8053C14.2723 11.9821 14.1649 12.1428 14.0296 12.2781C13.8942 12.4135 13.7336 12.5208 13.5567 12.5941C13.3799 12.6673 13.1904 12.705 12.999 12.705ZM12.999 7.1665C11.9166 7.1665 10.8786 7.59647 10.1133 8.3618C9.34793 9.12714 8.91797 10.1652 8.91797 11.2475C8.91797 14.3083 12.999 18.8265 12.999 18.8265C12.999 18.8265 17.08 14.3083 17.08 11.2475C17.08 10.1652 16.65 9.12714 15.8847 8.3618C15.1193 7.59647 14.0813 7.1665 12.999 7.1665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.864139c1429aa6d76e1b93827689cc3f.svg";
export { ForwardRef as ReactComponent };